import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface IdeasForLongerSleepDialogProps extends HelpDialogLayoutProps {}
export default function IdeasForLongerSleepDialog(
  props: IdeasForLongerSleepDialogProps
) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">15分だけでも長く寝よう</Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "前提として、睡眠は「まとまった時間でしっかり眠ること」がとても大切です。レム睡眠・ノンレム睡眠という言葉を聞いたことがあるかもしれませんが、人の睡眠はまず深いノンレム睡眠から始まり、朝に向かってレム睡眠が増えていきます。そのため、睡眠時間が短いと、後半に多いレム睡眠を十分にとれずに起きることになってしまいます。レム睡眠とノンレム睡眠のサイクルを一晩で繰り返していくことで、体や脳はしっかり回復できるのです。睡眠時間を30分や1時間延ばすことが難しい場合、一日15分でも延ばせないか考えてみてください。",
              ]}
            />
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">
            睡眠時間が足りなかった日の対応
          </Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "毎日睡眠時間を確保するのが理想ですが、早起きが必要な日や、飲み会などで夜更かししてしまう日もあると思います。そんな時は、次の日に「朝ゆっくり寝て睡眠時間を取り戻す」のではなく、「翌日の夜に早く寝る」ことをおすすめします。朝寝坊をすると体内時計がずれてしまい、かえって翌日以降のリズムに影響してしまいます。起床時刻はいつも通りにしてリズムを崩すことなく、夜早く寝ることで、前日の睡眠不足を取り戻しましょう。",
              ]}
            />
          </ContentStack>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">夕方以降の"寝落ち"に注意</Typography>
          <ContentStack>
            <BodyTypographies
              contents={[
                "睡眠不足だと、帰りの電車の中や夕食後にうとうとして、つい寝落ちしてしまうことがあります。こうした仮眠は一時的に眠気をやわらげることはあっても、まとまった睡眠ではないため、しっかりとした回復にはつながりません。特に夕食後のソファでの寝落ちが習慣になっている方は、その分、早めに寝床に入るように工夫してみてください。また、お子さんの寝かしつけで一緒に寝てしまう方は、夜中に起き直すよりも、そのまま一緒に眠り、朝早く起きて家事などをするスタイルに変えるのもひとつの方法です。",
              ]}
            />
          </ContentStack>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
